import React, { useEffect, useState } from "react";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { Checkbox, Grid, MenuItem } from "@mui/material";
import FilterSelect from "../../../../components/select/filterSelect";
import AutocompleteSelect from "../../../../components/select/autoCompleteSelect";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { InputValueNewAdvisor } from "../../../../domains/advisor";
import InputTextField from "../../../../components/input/inputTextField";
import InputDatePicker from "../../../../components/input/inputDatePicker";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import { advisorFormApi } from "../../../../api/advisor-form/advisor-form.api";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { advisorApi } from "../../../../api/advisor/advisor.api";
import { colors } from "../../../../constants/colors";
import { useTranslation } from "react-i18next";

type ModalSearchAdvisorProps = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  inputValue: InputValueNewAdvisor;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueNewAdvisor>>;
  action: string;
  selectedFaculties: any[];
  setSelectedFaculties: React.Dispatch<React.SetStateAction<any>>;
  handleSubmit?: () => void;
  isCanEdit: boolean;
  setIsCanEdit: (isOpen: boolean) => void;
  errorMessage: any[];
  singleDataAdvisor?: any;
  setSingleRawData?: React.Dispatch<React.SetStateAction<any>>;
};

const ModalSearchAdvisor: React.FC<ModalSearchAdvisorProps> = ({
  isOpenModal,
  setIsOpenModal,
  inputValue,
  setInputValue,
  action,
  selectedFaculties,
  setSelectedFaculties,
  handleSubmit,
  isCanEdit,
  setIsCanEdit,
  errorMessage,
  singleDataAdvisor,
  setSingleRawData,
}) => {
  const { t } = useTranslation();
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [dataAdvisorForm, setDataAdvisorForm] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [isEmployeeAlready, setIsEmployeeAlready] = useState<boolean>(false);
  // const [employeeDetail, setEmployeeDetail] = useState<any>({
  //   employee_id: null,
  //   fullname: "",
  //   employee_no: "",
  //   position: "",
  //   department: "",
  // });

  const getDataAsvisors = async () => {
    let query: any = {
      page: 1,
      limit: 100000,
    };

    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      console.log("data.data.items", data.data.items);
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getDataAdvisorFormEvaluation = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorFormApi.getAllAdvisorForm(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorForm(data.data.items);
    } else {
      setDataAdvisorForm([]);
    }
  };

  const getDataFaculty = async () => {
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  useEffect(() => {
    getDataEmployee();
    getDataAdvisorFormEvaluation();
    getDataFaculty();
    getDataAsvisors();
  }, []);

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  // useEffect(() => {
  //   if (action === "create") {
  //     setIsCanEdit(true);
  //   } else {
  //     setIsCanEdit(false);
  //   }
  // }, [action]);

  const getSingleAdvisor = async (id: number) => {
    const res = await advisorApi.getAdvisorById(id);
    const data = res.data;
    if (data.status < 300) {
      console.log("data.data", data.data);
      // setInputValue(data.data);
      setInputValue({
        advisor_id: data.data.id_advisor,
        adv_fullname: data.data.first_name + " " + data.data.last_name,
        adv_employee_id: data.data.id_employee,

        adv_employee_no: data.data.employee_no,
        adv_position: "",

        adv_position_name: "",
        adv_department: data.data.id_department,
        adv_department_name: "",

        start_date: data.data.advisor_start_date,
        course: data.data.faculty_names,
        evaluation_form: data.data.id_advisor_form,
        maximum_student: data.data.number_students,
        count_advisor_req: data.data.count_advisor_req,
        count_req_all: data.data.count_req_all,
      });
      setSelectedFaculties(data.data.faculty_names ?? []);
      setSingleRawData && setSingleRawData(data.data.faculty_names ?? []);
    } else {
      setSelectedFaculties([]);
      setInputValue({
        adv_fullname: "",
        adv_employee_id: "",
        adv_employee_no: "",
        adv_position: "",
        adv_position_name: "",
        adv_department: "",
        adv_department_name: "",
        start_date: new Date(),
        course: [],
        evaluation_form: 0,
        maximum_student: 0,
        count_advisor_req: 0,
        count_req_all: 0,
      });
    }
  };

  useEffect(() => {
    if (inputValue.advisor_id) {
      getSingleAdvisor(inputValue.advisor_id);
      setIsEmployeeAlready(false);
    }
  }, [inputValue.advisor_id]);

  console.log("dataAdvisor ", dataAdvisor);

  const getHelperText = () => {
    if (isEmployeeAlready) {
      return "Employee is already an advisor";
    }
    if (errorMessage.includes("adv_employee_id")) {
      return "Employee is required.";
    }
    return "";
  };

  // Function to handle checkbox toggle
  // const handleCheckboxChange = (option: any) => {
  //   console.log("handleCheckboxChange", option);
  //   console.log("selectedFaculties", selectedFaculties);

  //   const isSelected = selectedFaculties.filter(
  //     (faculty: any) => +faculty.id_faculty === +option.id_faculty
  //   );

  //   if (isSelected.length === 0) {
  //     setSelectedFaculties(option ?? []);
  //   } else {
  //     // filter data
  //     const new_data = selectedFaculties.filter(
  //       (faculty: any) => +faculty.id_faculty !== +option.id_faculty
  //     );

  //     setSelectedFaculties(new_data ?? []);
  //   }
  // };

  return (
    <ModalCustom
      title={
        action === "create"
          ? t("เพิ่มอาจารย์ที่ปรึกษาวิทยานิพนธ์")
          : t("แก้ไขข้อมูลอาจารย์ที่ปรึกษา")
      }
      subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนทำการยืนยัน")}
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
        setSelectedFaculties([]);
        setInputValue({
          ...inputValue,
          advisor_id: 0,
        });
      }}
      component={
        <Grid container spacing={2}>
          {action === "create" ? (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                alignSelf: "end",
              }}
            >
              <AutocompleteSelect
                helperText={getHelperText()}
                required
                heading={t("ค้นหาอาจารย์ที่ปรึกษา")}
                freeSolo
                labelId={"-"}
                options={dataEmployee ?? []}
                getOptionLabel={(option: any) => `${option?.fullname}` || ""}
                renderOption={(props, option) => (
                  <li {...props}>{`${option?.fullname}`}</li>
                )}
                // value={inputValue.adv_employee_id ?? null}
                onChange={(_, value: any) => {
                  if (value) {
                    // setEmployeeDetail({
                    //   employee_id: value.id_employee ?? null,
                    //   fullname: value.fullname ?? "",
                    //   employee_no: value.employee_no ?? "",
                    //   position: value.position_name ?? "",
                    //   department: value.department ?? "",
                    //   // value?.id_employee
                    // });
                    handleChangeValue("adv_employee_id", value.id_employee);
                    handleChangeValue("adv_fullname", value.fullname);
                    handleChangeValue("adv_employee_no", value.employee_no);
                    handleChangeValue("adv_position", value.id_position);
                    handleChangeValue("adv_position_name", value.position_name);
                    handleChangeValue("adv_department", value.id_department);
                    handleChangeValue("adv_department_name", value.department);
                  }
                }}
              />
            </Grid>
          ) : null}
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <InputTextField
              heading={t("ชื่อ-นามสกุล")}
              value={inputValue.adv_fullname}
              disabled={true}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={6}>
            <InputTextField
              heading={t("เลขประจำตัวเจ้าหน้าที่")}
              value={inputValue.adv_employee_no}
              disabled={true}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={6}>
            <InputTextField
              heading={t("ตำแหน่งงาน")}
              value={
                action === "create"
                  ? inputValue.adv_position_name
                  : singleDataAdvisor?.position_name
              }
              disabled={true}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={6}>
            <InputTextField
              heading={t("หน่วยงาน")}
              value={
                action === "create"
                  ? inputValue.adv_department_name
                  : singleDataAdvisor?.department_name_th
              }
              disabled={true}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <InputDatePicker
              heading={t("วันที่เริ่มต้น")}
              value={inputValue.start_date}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeValue("start_date", e);
              }}
              disabled={!isCanEdit}
              helperText={
                errorMessage.includes("start_date")
                  ? "Start Date is required."
                  : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            {/* dataFaculty */}
            <AutocompleteSelect
              heading={t("หลักสูตร")}
              multiple
              helperText={
                errorMessage.includes("course") ? "Course is required." : ""
              }
              required
              labelId="faculty-select"
              // options={dataFaculty}
              options={dataFaculty.map((item, index) => ({
                id_faculty: item.id_faculty,
                faculty_name: item.faculty_name,
              }))}
              // inputLabel="Select Faculty"
              getOptionLabel={(option: any) => option?.faculty_name || ""}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;

                // Check if the current option is selected
                const isSelected = selectedFaculties.some(
                  (faculty: any) => faculty.id_faculty === option.id_faculty
                );

                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={isSelected} // Mark checkbox as checked if selected
                      sx={{
                        color: isSelected ? colors.subPrimary : "default", // Change color when checked
                        "&.Mui-checked": {
                          color: colors.subPrimary, // Use green when checked
                        },
                      }}
                    />
                    {option.faculty_name}
                  </li>
                );
              }}
              // value={selectedFaculties}
              value={selectedFaculties.map((item: any, index: number) => ({
                id_faculty: item.id_faculty,
                faculty_name: item.faculty_name,
              }))}
              onChange={(_, value: any[]) => {
                const updatedFaculties = selectedFaculties.filter(
                  (faculty: any) =>
                    value.some(
                      (newFaculty: any) =>
                        newFaculty.id_faculty === faculty.id_faculty
                    )
                );

                const addedFaculties = value.filter(
                  (newFaculty: any) =>
                    !selectedFaculties.some(
                      (faculty: any) =>
                        faculty.id_faculty === newFaculty.id_faculty
                    )
                );

                setSelectedFaculties([...updatedFaculties, ...addedFaculties]);
              }}
              disabled={!isCanEdit}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <InputTextField
              heading={t("จำนวนที่รับนักศึกษาได้สูงสุด")}
              value={inputValue.maximum_student}
              disabled={!isCanEdit}
              type="number"
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                // Strip leading zeros and update the state
                const value = e.target.value.replace(/^0+/, ""); // Remove leading zeros
                handleChangeValue(
                  "maximum_student",
                  value === "" ? "0" : value
                ); // Set to '0' if empty
              }}
              helperText={
                errorMessage.includes("maximum_student")
                  ? "Maximum Student is required."
                  : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <FilterSelect
              heading={t("แบบฟอร์มประเมิน")}
              value={inputValue.evaluation_form ?? ""}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeValue("evaluation_form", e.target.value);
              }}
              placeholder={t("เลือกแบบฟอร์มประเมิน")}
              options={[
                // {
                //   value: 0,
                //   label: "เลือกแบบฟอร์มประเมิน",
                // },
                ...dataAdvisorForm.map((item, index) => ({
                  value: item.id_advisor_form,
                  label: item.advisor_form_name,
                })),
              ].map((option: any) => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
              disabled={!isCanEdit}
              labelId={""}
              selectId={""}
              helperText={
                errorMessage.includes("evaluation_form")
                  ? "Evaluation Form is required."
                  : ""
              }
              required
            />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
                setSelectedFaculties([]);
                setInputValue({
                  ...inputValue,
                  advisor_id: 0,
                });
              }}
              mode="del"
              buttonName={t("ยกเลิก")}
              btnProps={{
                width: "125px",
                margin: "12px",
              }}
            />

            <>
              {isCanEdit ? (
                <ButtonPrimary
                  disabled={selectedFaculties?.length == 0 || !inputValue.adv_employee_id || !inputValue.maximum_student || Number(inputValue.maximum_student) < 1 || !inputValue.evaluation_form || !inputValue.start_date}
                  onClick={() => {
                    if (action === "create") {
                      const isExistingEmployee = dataAdvisor.some(
                        (item) =>
                          item.id_employee === inputValue.adv_employee_id
                      );

                      if (!isExistingEmployee) {
                        handleSubmit && handleSubmit();
                      } else {
                        setIsEmployeeAlready(true);
                      }
                    } else {
                      handleSubmit && handleSubmit();
                    }
                    // setIsOpenModal(false);
                  }}
                  mode="success"
                  buttonName={t("ยืนยัน")}
                  btnProps={{
                    width: "125px",
                    margin: "12px",
                  }}
                />
              ) : (
                <ButtonPrimary
                  onClick={() => {
                    setIsCanEdit(true);
                  }}
                  buttonName={t("แก้ไข")}
                  btnProps={{
                    width: "125px",
                    margin: "12px",
                  }}
                />
              )}
            </>
          </Grid>
        </Grid>
      }
    />
  );
};

export default ModalSearchAdvisor;
